import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api'
import store from './store/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import './assets/css/modalStyle.css'

Vue.use(iView)

Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(api)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js